"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractsApi = void 0;
exports.contractsApi = (http, prefix = '/contracts') => ({
    getChannelsForCustomer(customerId) {
        return http.get(`${prefix}/channels/customer/${customerId}`);
    },
    updateChannelsForCustomer(customerId, contracts) {
        return http.put(`${prefix}/channels/customer/${customerId}`, contracts);
    },
    getTermsForCustomer(customerId) {
        return http.get(`${prefix}/terms/customer/${customerId}`);
    },
    agreeToTermsForCustomer(customerId, contracts) {
        return http.put(`${prefix}/terms/customer/${customerId}`, contracts);
    }
});
//# sourceMappingURL=index.js.map